module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNpiYBi54MyZMwLUMIcJie0ANPQ8ECdQYjgjmiv7gVQBEH8A4g1APNHExOQCJQaCXLYfiA2QhEEGTgRZADT8A0kGQg0FGXYei1qiXM2II4JA3u7H4xCcrmbEE+sgrzsQ8CHM1Y1Agx+gxzJVAAseLztQxcuURgoLlmQzn1jXEOPlemgaJDthsyC5LgAabonEuoYuhcMIBAABBgCIlE7sNFcZkwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/about/arrow.png
// module id = cFsL
// module chunks = 43